import React from 'react';
import GetgithubUsers from './components/GetgithubUsers';
import './App.css';


function App() {
  return (
    <>
      <GetgithubUsers />
    </>
  );
}

export default App;
